import { Button, Modal } from 'antd';
import '../../assets/css/calendar-colours-modal.css';

function CalendarKeyItem({ colour, withTriangle = false, name, description }) {
  return (
    <div>
      <div className={'display-flex-row mg-bottom-5'}>
        <div
          className={
            'w-24 h-24 br5 mg-right-10 ' +
            (withTriangle ? 'key-item-with-triangle ' : '')
          }
          style={{ backgroundColor: colour }}
        />
        <h3 className={'gBold fs-17'}>{name}</h3>
      </div>
      <div className={'gMedium fs-16'}>{description}</div>
    </div>
  );
}

export default function CalendarColoursModal({ visible, onClose }) {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={'min(95%, 40rem)'}
      title={null}
      footer={null}
      closable={false}
      maskClosable
      centered
    >
      <h2 className={'gSemiBold txt-center w-full fs-26'}>Booking Help</h2>
      <div className={'display-flex-column gap-2r'}>
        <CalendarKeyItem
          colour={'#C92222'}
          name={'Fully Booked'}
          description={
            <>
              If a date is a showing as red, it indicates that there are no
              available arrival or departure times for the number of tickets
              selected.
            </>
          }
        />
        <CalendarKeyItem
          colour={'#F2AA22'}
          name={'Limited Availability'}
          description={
            <>
              If a date is showing as orange, it indicates that all day sessions
              are fully booked for the number of tickets selected. However, you
              can still select it as the previous or following night session
              might still be available.
            </>
          }
        />
        <CalendarKeyItem
          colour={'#CEEFC8'}
          name={'Available Date'}
          description={
            <>
              If a date is showing as green, it indicates that all time slots
              for that date are available to be booked.
            </>
          }
        />
        <CalendarKeyItem
          colour={'#CEEFC8'}
          withTriangle
          name={'Night Session Unavailable'}
          description={
            <>
              If a green date is showing with a small red marker, it indicates
              that the night session of that date is fully booked for the number
              of tickets selected. You can still select this date for a day
              session.
            </>
          }
        />
        <Button
          className={'w-full sb-blue-bg br10 white pd-8 h-fit gSemiBold fs-18'}
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
}
